import script from "./popup-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./popup-header.vue?vue&type=script&lang=ts&setup=true"

import "./popup-header.vue?vue&type=style&index=0&id=1077409c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1077409c"]])

export default __exports__